import {Modal, Text} from '@mantine/core';
import Image from 'next/image';
import {useState} from 'react';
import {
  androidAppStoreUrl,
  iosAppStoreUrl,
} from '../../../../../config/constants/appUrl';
import {
  APP_STORE_ANDROID_IMAGE,
  APP_STORE_IOS_IMAGE,
  NEW_LOGO_IMAGE_PATH_APP_ICON,
} from '../../../../../config/constants/img';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {getMobileDeepLinks} from '../../../../../shared/services/getMobileDeepLinks';
import {
  MOBILE_OS_UNKNOWN,
  getMobileOS,
} from '../../../../../shared/services/getMobileOS';

export const SpComponent: React.FC = () => {
  const [isModalOpened, setIsModalOpened] = useState(true);
  const [isErrorModalOpened, setIsErrorModalOpened] = useState(false);

  const mobileOS = getMobileOS();
  const mobileDeepLinks = getMobileDeepLinks(mobileOS);

  const closeModal = () => {
    setIsModalOpened(false);
  };

  const errorModalHandler = () => {
    if (mobileOS === MOBILE_OS_UNKNOWN) {
      setIsErrorModalOpened(true);
    } else {
      window.location.href = mobileDeepLinks;
    }
  };

  return (
    <>
      <Modal
        opened={isModalOpened}
        onClose={closeModal}
        withCloseButton={true}
        closeButtonProps={{
          style: {width: '24px', height: '24px'},
          iconSize: 20,
        }}
        radius={16}
        centered={true}
        sx={{
          '.mantine-Modal-body': {
            paddingTop: '20px',
            paddingBottom: '20px',
            paddingLeft: '10px',
            paddingRight: '10px',
          },
        }}
      >
        <div className="bg-white rounded-[16px] p-6 shadow-lg flex flex-col items-center shadow-lg">
          <div className="w-full flex justify-center my-20">
            <Image
              src={NEW_LOGO_IMAGE_PATH_APP_ICON}
              width={128}
              height={128}
              alt={'logo'}
              className="rounded-[16px] mt-8"
            />
          </div>
          <div className="mx-20">
            <p className="text-xl font-bold mt-8">続きはアプリで。</p>
            <p className="mt-8 mb-[60px]">
              外資就活コミュニティはアプリでご覧いただけます。
            </p>
            <button
              className="text-[14pt] justify-center text-white py-12 w-[100%] rounded-full mb-12 shadow-2xl active:scale-[0.97]"
              style={{
                background:
                  'linear-gradient(98.19deg, rgba(245, 123, 115, 0.9) 50%, #F6D16A 100%)',
              }}
              onClick={() => {
                errorModalHandler();
              }}
            >
              ダウンロード
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        opened={isErrorModalOpened}
        onClose={() => {
          setIsErrorModalOpened(false);
        }}
        title="エラー"
        centered
      >
        <Text>外資就活のアプリはiOSとAndroidでご利用いただけます。</Text>
      </Modal>
      <div className="w-full">
        <div className="bg-white p-16">
          <p className="text-md text-black-1 leading">
            コミュニティを利用するにはアプリをダウンロードしてください
          </p>
          <div className="flex justify-center items-center mt-16">
            <CommonLink
              href={iosAppStoreUrl}
              target="_blank"
              rel="noreferrer"
              className="block mr-8"
            >
              <Image
                src={APP_STORE_IOS_IMAGE}
                width={120}
                height={40}
                alt={'iOS App Storeでアプリをダウンロード'}
              />
            </CommonLink>
            <CommonLink
              href={androidAppStoreUrl}
              target="_blank"
              rel="noreferrer"
              className="block"
            >
              <Image
                src={APP_STORE_ANDROID_IMAGE}
                width={120}
                height={40}
                alt={'Google Play Storeでアプリをダウンロード'}
              />
            </CommonLink>
          </div>
        </div>
      </div>
    </>
  );
};
